import CalendarItemWithPerformanceCodeParticipation from './CalendarItemWithPerformanceCodeParticipation';

export default {
    ...CalendarItemWithPerformanceCodeParticipation,
    name: 'treatment_participation_payment_status_resource',
};
